<template>
  <div>
    <PreRegistrationModal />
  </div>
</template>

<script>
  import {getParameterByName, isMobile} from '@/js/common/util';
  import {
    otmUserServerUrl,
    USER_V3_STATE_TYPE,
    REGISTRATION_V1_URL,
    CURRENT_USER_STATE,
    CUSTOM_COMPANIES,
  } from '@/js/common/constants';
  import examRoom from '@/mixins/exam_room';
  import info from '@/mixins/info';
  import '@/assets/css/style.css';
  import PreRegistrationModal from '@/components/modal/PreRegistrationModal';

  export default {
    name: 'Link',
    mixins: [examRoom, info],
    components: {
      PreRegistrationModal,
    },
    data() {
      return {
        userInfo: {},
        examInfo: {},
        examPeriodInfo: {},
        isMobilePageMoveId: [
          CUSTOM_COMPANIES.KUMON,
          CUSTOM_COMPANIES.HANJA,
          CUSTOM_COMPANIES.KBS,
        ],
        userId: getParameterByName('userid'),
      };
    },
    async created() {
      const {user, exam, period} = await this.fetchData(this.userId);
      if (user && exam && period) {
        this.userInfo = user;
        this.examInfo = exam;
        this.examPeriodInfo = period;
        this.onUserType();
      }
    },
    methods: {
      onUserType() {
        const {isPreRegistered, companyId} = this.userInfo;

        if (isPreRegistered) {
          this.preRegistrationComplete();
          return;
        }

        if (isMobile() && this.isMobilePageMoveId.includes(companyId)) {
          const registrationUrl = `${REGISTRATION_V1_URL}${window.location.search}`;
          location.replace(registrationUrl);
          return;
        }

        this.preRegistrationNotComplete();
      },

      // 사전등록 미완료
      preRegistrationNotComplete() {
        location.replace(
          `${otmUserServerUrl}/${USER_V3_STATE_TYPE['PRE_REGISTRATION']}${window.location.search}`,
        );
      },

      preRegistrationComplete() {
        const examStatus = this.getStatus(
          this.examInfo,
          this.examPeriodInfo,
          this.userInfo,
        );

        if (examStatus.state !== CURRENT_USER_STATE.EXAM_ON) {
          this.preRegistrationNotComplete();
          return;
        }

        if (!this.examInfo.faceEvent) {
          this.moveExamRoom();
          return;
        }

        setTimeout(() => {
          location.replace(
            `${otmUserServerUrl}/${USER_V3_STATE_TYPE['LOGIN']}${window.location.search}`,
          );
        }, 1000);
        return;
      },
    },
  };
</script>
